import React, { Component, Fragment } from "react";
import PopUpForm from "../../../Generic/PopUpDialog/PopUpForm";
import { connect } from "react-redux";
import { API } from "aws-amplify";

//Actions
import { setRefresh } from "../../../../actions/algoliaActions";
import { setAlgoliaLoaderState } from "../../../../actions/loaderActions";
import PopUp from "../../../Generic/PopUpDialog/PopUp";
import config from "../../../../config";

class CreateCurtainDriveMechanismPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypes: [
        {
          id: "name",
          label: "Drive Mechanism Name",
          type: "text",
          tooltip: "Please Enter Drive Name",
          required: true,
          value: "",
        },
        {
          id: "cost",
          label: "Drive Cost",
          type: "number",
          tooltip: "Please Enter Cost",
          required: true,
          value: 0,
        },
        {
          id: "markup",
          label: "Drive Markup",
          type: "number",
          tooltip: "Please Enter Markup",
          required: true,
          value: 0,
        },
        {
          id: "manufacturerId",
          label: "Manufacturer ID",
          type: "AlgoliaSelect",
          index: `${config.algolia.prefix}manufacturers_name_asc`,
          filters: "isDeleted:false",
          value: "",
        },
        {
          id: "associatedServices",
          label: "Associated Services",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_services_fees_name_asc`,
          value: [],
        },
      ],
      fields: { name: "", cost: 0, markup: 0 },
      step: 1,
      mechanisimType: "manual",
    };
  }
  handleCancelClick = () => {
    this.props.history.goBack();
  };

  onDriveTypeChange = (event) => {
    this.setState({ mechanisimType: event.target.value });
    if (event.target.value === "manual") {
      this.setState({
        validationTypes: [
          {
            id: "name",
            label: "Style Name",
            type: "text",
            tooltip: "Please Enter Drive Name",
            required: true,
            value: "",
          },
          {
            id: "cost",
            label: "Drive Cost",
            type: "number",
            tooltip: "Please Enter Cost",
            required: true,
            value: 0,
          },
          {
            id: "markup",
            label: "Drive Markup",
            type: "number",
            tooltip: "Please Enter Markup",
            required: true,
            value: 0,
          },
          {
            id: "manufacturerId",
            label: "Manufacturer ID",
            type: "AlgoliaSelect",
            index: `${config.algolia.prefix}manufacturers_name_asc`,
            filters: "isDeleted:false",
            value: "",
          },
          {
            id: "associatedServices",
            label: "Associated Services",
            type: "multiSelect",
            index: `${config.algolia.prefix}products_services_fees_name_asc`,
            value: [],
          },
        ],
        fields: { name: "", cost: 0, markup: 0 },
      });
    }
    if (event.target.value === "motorised") {
      this.setState({
        validationTypes: [
          {
            id: "name",
            label: "Drive Mechanism Name",
            type: "text",
            tooltip: "Please Enter Drive Name",
            required: true,
            value: "",
          },
          {
            id: "cost",
            label: "Drive Cost",
            type: "number",
            tooltip: "Please Enter Cost",
            required: true,
            value: 0,
          },
          {
            id: "markup",
            label: "Drive Markup",
            type: "number",
            tooltip: "Please Enter Markup",
            required: true,
            value: 0,
          },
          {
            id: "power",
            label: "Drive Power",
            type: "number",
            tooltip: "Please Enter Power",
            required: true,
            value: 0,
          },
          {
            id: "speed",
            label: "Drive Speed",
            type: "number",
            tooltip: "Please Enter Speed",
            required: true,
            value: 0,
          },
          {
            id: "lift",
            label: "Drive Lift",
            type: "number",
            tooltip: "Please Enter Lift",
            required: true,
            value: 0,
          },
          {
            id: "manufacturerId",
            label: "Manufacturer ID",
            type: "AlgoliaSelect",
            index: `${config.algolia.prefix}manufacturers_name_asc`,
            filters: "isDeleted:false",
            value: "",
          },
          {
            id: "associatedServices",
            label: "Associated Services",
            type: "multiSelect",
            index: `${config.algolia.prefix}products_services_fees_name_asc`,
            value: [],
          },
        ],
        fields: { name: "", cost: 0, markup: 0, power: 0, speed: 0, lift: 0 },
      });
    }
  };

  handleNextClick = () => {
    this.setState({ step: 2 });
  };

  APIMethod = async (formData) => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      let body = {};
      if (this.state.mechanisimType === "manual")
        body = {
          details: {
            name: formData.name,
            cost: formData.cost,
            markup: formData.markup,
            associatedServices: formData.associatedServices,
            manufacturerId: formData.manufacturerId,
          },
        };
      if (this.state.mechanisimType === "motorised")
        body = {
          details: {
            name: formData.name,
            cost: formData.cost,
            markup: formData.markup,
            power: formData.power,
            speed: formData.speed,
            lift: formData.lift,
            associatedServices: formData.associatedServices,
            manufacturerId: formData.manufacturerId,
          },
        };
      await API.post(
        "telishadeAPI",
        "/product/curtain/component/drive-mechanism-" + this.state.mechanisimType,
        { body }
      );
      this.props.history.push(`/products/curtains/drive-mechanism`);
      this.props.dispatch(setRefresh(true));
      this.props.dispatch(setAlgoliaLoaderState(false));
    } catch (e) {
      this.props.dispatch(setAlgoliaLoaderState(false));
      throw e;
    } finally {
      // Refresh any algolia components currently mounted 1 second after updating
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
      }, 0);
    }
  };

  render() {
    return this.state.step === 1 ? (
      <PopUp
        header="Add New Curtain Drive"
        body={
          <Fragment>
            <label className="datefieldLabel">Mechanism Type</label>
            <select
              value={this.state.mechanisimType}
              onChange={this.onDriveTypeChange}
              className="browser-default custom-select form-control"
            >
              <option value="manual" label="Manual" />
              <option value="motorised" label="Motorised" />
            </select>
          </Fragment>
        }
        button="Next"
        buttoncolour="blue"
        buttonClickHandler={this.handleNextClick}
        button2="Cancel"
        button2colour="red"
      />
    ) : this.state.step === 2 ? (
      <PopUpForm
        fields={this.state.validationTypes}
        apiMethod={this.APIMethod}
        header="Add New Curtain Drive"
        button="Accept"
        buttoncolour="green"
        button2="Cancel"
        button2colour="red"
      />
    ) : (
      ""
    );
  }
}

export default connect()(CreateCurtainDriveMechanismPopUp);
